export default () => ({
    currentSlide: '3',
    lastSlide: '3',
    totalSlides: -1,

    init() {
        const gallery = document.querySelector('.gallery')
        const figures = Array.from(gallery.querySelectorAll('figure[data-slide]'))
        this.totalSlides = figures.length;
        if (figures.length>5 && figures.length % 2 == 0) {
            gallery.classList.add("offset");
        }
        this.reorderSlides()
        this.updateContentSlide(this.currentSlide)
    },

    next() {
        this.lastSlide = this.currentSlide
        this.currentSlide = this.wrapIndex(parseInt(this.currentSlide) + 1)
        this.reorderSlides()
    },

    prev() {
        this.lastSlide = this.currentSlide
        this.currentSlide = this.wrapIndex(parseInt(this.currentSlide) - 1)
        this.reorderSlides()
    },

    wrapIndex(n) {
        return (((n - 1 + this.totalSlides) % this.totalSlides) + 1).toString()
    },

    // reorder the grid
    reorderSlides() {
        const gallery = document.querySelector('.gallery')
        const figures = Array.from(gallery.querySelectorAll('figure[data-slide]'))
        const current = parseInt(this.currentSlide)
        const previous = parseInt(this.lastSlide)

        const direction =
            current > previous ||
            (current === 1 && previous === this.totalSlides)
                ? 'left'
                : 'right'

        const controls = gallery.querySelector('.gallery__controls')

        const ordered = []

        figures.forEach(slide => {
            slide.classList.add(`tohide`)
        })

        for (let i = -2; i <= 2; i++) {
            let index = current + i

            if (index < 1) index += this.totalSlides
            if (index > this.totalSlides) index -= this.totalSlides

            const slide = figures.find(
                el => parseInt(el.dataset.slide) === index
            )

            if (slide) {
                slide.classList.remove(`hide`)
                slide.classList.remove(`tohide`)
                ordered.push(slide)
            }
        }

        // mark outgoing slides for animation
        figures.forEach(slide => {
            if (slide.classList.contains('tohide')) {
                slide.classList.add(`hide`)
            }
            if (!ordered.includes(slide)) {
                slide.classList.add(`slide-out-${direction}`)
            }
        })

        setTimeout(() => {
            ordered.forEach(slide => {
                slide.classList.remove(`slide-out-${direction}`)

                const isActive = parseInt(slide.dataset.slide) === current
                if (isActive) slide.classList.add('is-active-slide')

                slide.classList.add(`slide-in-${direction}`)
                gallery.insertBefore(slide, controls)
            })

            figures.forEach(slide => {
                const isActive = parseInt(slide.dataset.slide) === current
                slide.classList.toggle('--active', isActive)

                slide.addEventListener(
                    'animationend',
                    () => {
                        slide.classList.remove(
                            `slide-in-${direction}`,
                            'is-active-slide'
                        )
                    },
                    { once: true }
                )
            })
        }, 50)
    },

    // update active slide content
    updateContentSlide(currentSlide) {
        if (this) currentSlide = this.currentSlide
        const galleryContent = this.$el.querySelectorAll('.gallery__content')
        galleryContent.forEach(el => {
            const isCurrent = el.dataset.slide == currentSlide
            el.classList.toggle('--active', isCurrent)
        })
    },
})
